import { Link } from "react-router-dom";
import Header from "./common/Header";
import Sidebar from "./common/Sidebar";
import Recharge from "./recharge";
import SuperDmtTwo from "./pages/superdmttwo";
// import SuperDmtThree from "./pages/superdmtthree";
import SecureMoneyTransfer from "./pages/securemoneytransfer";
import BbpsOnline from "./pages/bbpsonline";
import AepsNormalSettlement from "./pages/aepsnormalsettlement";
import NewAeps from "./pages/newaeps";
import WalletTransfer from "./pages/wallettransfer";
import BbpsOffline from "./pages/bbpsoffline";
// import KiaraBillPay from "./pages/kiarabillpay";
import CreditCard from "./pages/creditcard";
import Lpg from "./pages/lpg";
import FundTransfer from "./pages/fundtransfer";
import Lic from "./pages/lic";
import Fastag from "./pages/fastag";


export default function Dashboard() {
  return (
    <>
      <Header />
      <div className="adminuiux-wrap">
        <Sidebar />
        <main className="adminuiux-content has-sidebar">          
          <div className="container" id="main-content">
            <div
              className="row"
              style={{
                marginLeft: 0,
                marginRight: 0,
                paddingLeft: 0,
                paddingRight: 0,
                marginTop:"95px"
              }}
            >
              <div
                className="col-6 mb-4"
                style={{ paddingLeft: 0, paddingRight: 0 }}
              >
                <marquee
                  scrollamount={6}
                  style={{
                    fontSize: 18,
                    fontWeight: 800,
                    fontFamily: "math",
                    paddingTop: 5,
                    background: "rgb(255 202 25)"
                  }}
                  className="bionews"
                >
                  <p>
                    <span style={{ fontSize: 14 }}>
                      <strong>TATKAL SERVICE IS WORKING FINE</strong>
                    </span>
                  </p>
                </marquee>
              </div>
              <div
                className="col-6 mb-4"
                style={{ paddingLeft: 0, paddingRight: 0 }}
              >
                <marquee
                  scrollamount={6}
                  style={{
                    fontSize: 18,
                    fontWeight: 800,
                    fontFamily: "math",
                    paddingTop: 5,
                    background: "rgb(255 202 25)"
                  }}
                  className="bionews"
                >
                  Dear Partners Our Service Down Till 11:00 Pm To 08:00 Am
                </marquee>
              </div>
            </div>
            <div className="row">
              <div className="col-md-9  mb-2">
                <div className="row">
                  <div className="col-md-2 mb-3">
                    <Link to="/super-dmt-two" className="card adminuiux-card style-none text-center h-100" exact component={SuperDmtTwo}>
                      <small className="text-left serviceStD">Down</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/money (2).gif"
                          className="icon_size"
                        />
                        {/*<i class="avatar avatar-40 text-theme-1 h3 bi bi-bank mb-3"></i>*/}
                        <p className="text-secondary small bold">Tatkal Transfer</p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-2 mb-3">
                    <Link to="/secure-money-transfer" className="card adminuiux-card style-none text-center h-100" exact component={SecureMoneyTransfer}>
                      <small className="text-left serviceStL">Live</small>
                      <div className="card-body card-body-new">
                        <img src="service_icon/PPI.gif" className="icon_size" />
                        {/*<i class="avatar avatar-40 text-theme-1 bi bi-cash-stack h3 mb-3"></i>*/}
                        <p className="text-secondary small bold">Money Transfer</p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-2 mb-3">
                    <Link to="/bill-pay" className="card adminuiux-card style-none text-center h-100" exact component={BbpsOnline}>
                      <small className="text-left serviceStL">Live</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/Money Transfer.gif"
                          className="icon_size"
                        />
                        {/*<i class="avatar avatar-40 text-theme-1 h3 bi bi-bank mb-3"></i>*/}
                        <p className="text-secondary small bold">BBPS(Online)</p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-2 mb-3">
                    <a
                      href="#"
                      className="card adminuiux-card style-none text-center h-100"
                    >
                      <small className="text-left serviceStL">Live</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/rupee (1).gif"
                          className="icon_size"
                        />
                        {/*<i class="avatar avatar-40 text-theme-1 bi bi-currency-rupee h3 mb-3"></i>*/}
                        <p className="text-secondary small bold">UPI Transfer</p>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-2 mb-3">
                    <Link to="/aeps-normal-settlement" className="card adminuiux-card style-none text-center h-100" exact component={AepsNormalSettlement}>
                      <small className="text-left serviceStL">Live</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/exchange.gif"
                          className="icon_size"
                        />
                        {/*<i class="avatar avatar-40 text-theme-1 bi bi-person-walking h3 mb-3"></i>*/}
                        <p className="text-secondary small bold">AEPS Settlement</p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-2 mb-3">
                    <Link to="/new-aeps" className="card adminuiux-card style-none text-center h-100" exact component={NewAeps}>
                      <small className="text-left serviceStD">Down</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/fingerprint-scanner.gif"
                          className="icon_size"
                        />
                        {/*<i class="avatar avatar-40 text-theme-1 bi bi-building-lock h3 mb-3"></i>*/}
                        <p className="text-secondary small bold">AEPS</p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-2 mb-3">
                    <Link to="/wallet-transfer" className="card adminuiux-card style-none text-center h-100" exact component={WalletTransfer}>
                      <small className="text-left serviceStL">Live</small>
                      <div className="card-body card-body-new">
                        <img src="service_icon/wallet.gif" className="icon_size" />
                        {/*<i class="avatar avatar-40 text-theme-1 bi bi-calendar-event h3 mb-3"></i>*/}
                        <p className="text-secondary small bold">Wallet Transfer</p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-2 mb-3">
                    <Link to="/offline-pay" className="card adminuiux-card style-none text-center h-100" exact component={BbpsOffline}>
                      <small className="text-left serviceStL">Live</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/Electricity.gif"
                          className="icon_size"
                        />
                        {/*<i class="avatar avatar-40 text-theme-1 bi bi-shield-check h3 mb-3"></i>*/}
                        <p className="text-secondary small bold">
                          BBPS (Offline){" "}
                        </p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-2 mb-3">
                    <Link to="/bill-pay" className="card adminuiux-card style-none text-center h-100" exact component={BbpsOnline}>
                      <small className="text-left serviceStL">Live</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/Electricity 3.gif"
                          className="icon_size"
                        />
                        <p className="text-secondary small bold">
                          Electricity (Online)
                        </p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-2 mb-3">
                    <Link to="/credit-card" className="card adminuiux-card style-none text-center h-100" exact component={CreditCard}>
                      <small className="text-left serviceStD">Down</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/Credit Card.gif"
                          className="icon_size"
                        />
                        {/*<i class="avatar avatar-40 text-theme-1 bi bi-building-lock h3 mb-3"></i>*/}
                        <p className="text-secondary small bold">
                          Credit Card Payment
                        </p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-2 mb-3">
                    <Link to="/lpg" className="card adminuiux-card style-none text-center h-100" exact component={Lpg}>
                      <small className="text-left serviceStL">Live</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/biogas (1).gif"
                          className="icon_size"
                        />
                        {/*<i class="avatar avatar-40 text-theme-1 bi bi-building-lock h3 mb-3"></i>*/}
                        <p className="text-secondary small bold">LPG Gas</p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-2 mb-3">
                    <a
                      href="v4/kiara/water"
                      className="card adminuiux-card style-none text-center h-100"
                    >
                      <small className="text-left serviceStL">Live</small>
                      <div className="card-body card-body-new">
                        <img src="service_icon/Water.gif" className="icon_size" />
                        {/*<i class="avatar avatar-40 text-theme-1 bi bi-building-lock h3 mb-3"></i>*/}
                        <p className="text-secondary small bold">Water Bill</p>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-2 mb-3">
                    <Link to="/lic" className="card adminuiux-card style-none text-center h-100" exact component={Lic}>
                      <small className="text-left serviceStL">Live</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/protection (1).gif"
                          className="icon_size"
                        />
                        <p className="text-secondary small bold">LIC Payment</p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-2 mb-3">
                    <a
                      href="v4/kiara/gas"
                      className="card adminuiux-card style-none text-center h-100"
                    >
                      <small className="text-left bbpsSt">Live</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/gas-leak.gif"
                          className="icon_size"
                        />
                        {/*<i class="avatar avatar-40 text-theme-1 bi bi-building-lock h3 mb-3"></i>*/}
                        <p className="text-secondary small bold">Piped Gas Bill</p>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-2 mb-3">
                    <a
                      href="v4/kiara/insurance"
                      className="card adminuiux-card style-none text-center h-100"
                    >
                      <small className="text-left bbpsSt">Live</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/medical-insurance (1).gif"
                          className="icon_size"
                        />
                        {/*<i class="avatar avatar-40 text-theme-1 bi bi-building-lock h3 mb-3"></i>*/}
                        <p className="text-secondary small bold">Insurance</p>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-2 mb-3">
                    <Link to="/recharge/prepaid" className="card adminuiux-card style-none text-center h-100" exact component={Recharge}>
                      <small className="text-left serviceStL">Live</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/Recharge Icon.gif"
                          className="icon_size"
                        />
                        {/*<i class="avatar avatar-40 text-theme-1 bi bi-phone h3 mb-3"></i>*/}
                        <p className="text-secondary small bold">
                          Prepaid Recharge
                        </p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-2 mb-3">
                    <Link to="/recharge/dth" className="card adminuiux-card style-none text-center h-100" exact component={Recharge}>
                      <small className="text-left serviceStL">Live</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/satellite.gif"
                          className="icon_size"
                        />
                        {/*<i class="avatar avatar-40 text-theme-1 bi bi-umbrella h3 mb-3"></i>*/}
                        <p className="text-secondary small bold">DTH Recharge</p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-2 mb-3">                    
                      <Link to="https://kiaraapay.com/postpaid" className="card adminuiux-card style-none text-center h-100">
                      <small className="text-left serviceStL">Live</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/touch-screen.gif"
                          className="icon_size"
                        />                        
                        <p className="text-secondary small bold">
                          Postpaid Bill Payment
                        </p>
                      </div>
                      </Link>
                  </div>
                  <div className="col-md-2 mb-3">
                    <Link to="/fastag" className="card adminuiux-card style-none text-center h-100" exact component={Fastag}>
                      <small className="text-left serviceStL">Live</small>
                      <div className="card-body card-body-new">
                        <img src="service_icon/barrier.gif" className="icon_size" />
                        {/*<i class="avatar avatar-40 text-theme-1 bi bi-car-front-fill h3 mb-3"></i>*/}
                        <p className="text-secondary small bold">FASTag Recharge</p>
                      </div>
                    </Link>
                  </div>
                  <div className="col-md-2 mb-3">
                    <a href="#" className="card adminuiux-card style-none text-center h-100">
                      <small className="text-left serviceStL">Live</small>
                      <div className="card-body card-body-new">
                        <img
                          src="service_icon/cms-system.gif"
                          className="icon_size"
                        />
                        {/*<i class="avatar avatar-40 text-theme-1 bi bi-building-lock h3 mb-3"></i>*/}
                        <p className="text-secondary small bold">CMS</p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card adminuiux-card">
                  <div className="card-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h6>Today Summary</h6>
                      </div>
                      <div className="col-auto">
                        <button className="btn btn-sm btn-outline-theme">
                          Reload
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row gx-3 py-1 align-items-center">
                      <div className="col-6">
                        <Link to="/fund-transfer" className="btn btn-theme" style={{
                            marginLeft: "-12px",
                            background: "rgb(0 168 243)",
                            border: "none"
                          }} exact component={FundTransfer}>
                          + Add Money
                        </Link>
                      </div>
                      <div className="col-6">
                        <a
                          className="btn btn-outline-theme"
                          href="wallet-request"
                          style={{ fontSize: 15 }}
                        >
                          View Request
                        </a>
                      </div>
                    </div>
                  </div>
                  <ul className="list-group list-group-flush border-top bg-none">
                    <li
                      className="list-group-item"
                      style={{
                        backgroundImage:
                          "linear-gradient(rgb(255 202 25), rgb(0, 168, 243))"
                      }}
                    >
                      <div className="row gx-3 align-items-center">
                        <div className="col">
                          <p className="mb-1 fw-medium  small">
                            Opening : <span className="opening_bal" />
                          </p>
                        </div>
                        <div className="col-auto text-end">
                          <p className="mb-1 fw-medium  small">
                            Closing : <span className="closing_bal" />
                          </p>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item"
                      style={{
                        backgroundImage:
                          "linear-gradient(rgb(0, 168, 243), rgb(255 202 25))"
                      }}
                    >
                      <div className="row gx-3 align-items-center">
                        <div className="col">
                          <p className="mb-1 fw-medium  small">
                            Credit : <span className="fund_credit" />
                          </p>
                        </div>
                        <div className="col-auto text-end">
                          <p className="mb-1 fw-medium  small">
                            Debit : <span className="fund_debit" />
                          </p>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item"
                      style={{
                        backgroundImage:
                          "linear-gradient(rgb(255 202 25), rgb(0, 168, 243))"
                      }}
                    >
                      <div className="row gx-3 align-items-center">
                        <div className="col">
                          <p className="mb-1 fw-medium  small">
                            Comm. : <span className="cred_comm" />
                          </p>
                        </div>
                        <div className="col-auto text-end">
                          <p className="mb-1 fw-medium  small">
                            Charges : <span className="charges" />
                          </p>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item"
                      style={{
                        backgroundImage:
                          "linear-gradient(rgb(0, 168, 243), rgb(255 202 25))"
                      }}
                    >
                      <div className="row gx-3 align-items-center">
                        <div className="col">
                          <p className="mb-1 fw-medium  small">
                            TDS : <span className="tds" />
                          </p>
                        </div>
                        <div className="col-auto text-end">
                          <p className="mb-1 fw-medium  small">
                            Refund Pend. : <span className="refund_pending" />
                          </p>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item"
                      style={{
                        backgroundImage:
                          "linear-gradient(rgb(255 202 25), rgb(0, 168, 243))"
                      }}
                    >
                      <div className="row gx-3 align-items-center">
                        <div className="col">
                          <p className="mb-1 fw-medium  small">
                            Tatkal. : <span className="Tsuccess" />
                          </p>
                        </div>
                        <div className="col-auto text-end">
                          <p className="mb-1 fw-medium  small">PPI : 0</p>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item"
                      style={{
                        backgroundImage:
                          "linear-gradient(rgb(0, 168, 243), rgb(255 202 25))"
                      }}
                    >
                      <div className="row gx-3 align-items-center">
                        <div className="col">
                          <p className="mb-1 fw-medium  small">
                            Money Trf : <span className="success" />
                          </p>
                        </div>
                        <div className="col-auto text-end">
                          <p className="mb-1 fw-medium  small">UPI. : 0</p>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item"
                      style={{
                        backgroundImage:
                          "linear-gradient(rgb(255 202 25), rgb(0, 168, 243))"
                      }}
                    >
                      <div className="row gx-3 align-items-center">
                        <div className="col">
                          <p className="mb-1 fw-medium  small">
                            AEPS : <span className="aepssuccess" />
                          </p>
                        </div>
                        <div className="col-auto text-end">
                          <p className="mb-1 fw-medium  small">
                            Recharge. : <span className="successrec" />
                          </p>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item"
                      style={{
                        backgroundImage:
                          "linear-gradient(rgb(0, 168, 243), rgb(255 202 25))"
                      }}
                    >
                      <div className="row gx-3 align-items-center">
                        <div className="col">
                          <p className="mb-1 fw-medium  small">
                            Bill Pay : <span className="billpaysuccess" />
                          </p>
                        </div>
                        <div className="col-auto text-end">
                          <p className="mb-1 fw-medium  small">
                            BBPS. : <span className="successbbps" />
                          </p>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item"
                      style={{
                        backgroundImage:
                          "linear-gradient(rgb(0, 168, 243), rgb(255 202 25))"
                      }}
                    >
                      <div className="row gx-3 align-items-center">
                        <div className="col">
                          <p className="mb-1 fw-medium  small">LIC : 0</p>
                        </div>
                        <div className="col-auto text-end">
                          <p className="mb-1 fw-medium  small">Fastag. : 0</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>{" "}
      {/* adminuiux-wrap */}
      <div
        className="modal fade"
        id="fundModal"
        tabIndex={-1}
        aria-labelledby="fundModal"
        aria-hidden="true"
      >
        <form
          role="form"
          action="fund-request-slip"
          method="post"
          encType="multipart/form-data"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-theme-1-subtle  ">
                <p className="modal-title h5" id="fundModal">
                  Fund Request
                </p>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <input type="hidden" id="mtimes" name="mtime" />
                <input
                  type="hidden"
                  name="_token"
                  defaultValue="D4MMnG44EBV6yC223rVDL2C2RVJ8bJi6XQUumwtP"
                />
                <div className="mb-1">
                  <label className="form-label">Amount</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Amount"
                    id="amount"
                    name="amount"
                  />
                </div>
                <div className="mb-1">
                  <label className="form-label">Mode 0f Payment</label>
                  <select className="form-select tx-14" id="myid" name="myid">
                    <option value="IMPS / NEFT / RTGS ">IMPS / NEFT / RTGS </option>
                    <option value="CHEQUE">CHEQUE</option>
                    <option value="BY CASH HANDOVER">BY CASH HANDOVER</option>
                    <option value="CDM DEPOSIT">CDM DEPOSIT</option>
                    <option value="CASH DEPOSIT">CASH DEPOSIT</option>
                  </select>
                </div>
                <div className="mb-1">
                  <label className="form-label">To Bank Name</label>
                  <select
                    className="form-select tx-14"
                    id="paybankaccount"
                    name="paybankaccount"
                    required=""
                  >
                    <option value={59}>
                      PUNJAB NATIONAL BANK (1845005900000022)
                    </option>
                    <option value={60}>
                      AU SMALL FINANCE BANK (2302244648913363)
                    </option>
                    <option value={64}>AXIS BANK (CDM DEPOSIT)</option>
                    <option value={69}>AXIS BANK-2 (923020022521828)</option>
                    <option value={71}>STATE BANK OF INDIA (41448510508)</option>
                    <option value={74}>HDFC BANK (50200089941164)</option>
                    <option value={76}>YES BANK (107563700000490)</option>
                  </select>
                </div>
                <div className="mb-1">
                  <label className="form-label">Payment Date</label>
                  <input
                    className="form-control tx-14"
                    id="payment_date"
                    name="payment_date"
                    type="text"
                    defaultValue="2025-02-15"
                  />
                </div>
                <div className="mb-1">
                  <label className="form-label">Remark</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Remark"
                    id="remark"
                    name="remark"
                  />
                </div>
                <div className="mb-1">
                  <label className="form-label">Request To</label>
                  <select className="form-select" id="req_type" name="req_type">
                    {/*<option value="1">Request to Parent</option>*/}
                    <option value={2}>Request to Company</option>
                  </select>
                </div>
                <div className="mb-1">
                  <input
                    type="file"
                    id="payment_slip"
                    name="payment_slip"
                    accept="image/png, image/jpeg"
                  />
                  <label className="form-label">Slip</label>
                  <input
                    type="checkbox"
                    name="consent"
                    className="mt-4"
                    required=""
                  />{" "}
                  consent
                  <p>
                    {" "}
                    I hereby confirm the deposit referred to above has been made by
                    me on my behalf under my instruction I accept full
                    responsibility from the deposit some and shall defend and hold
                    harmless Kiaraa Pay technology private limited against any
                    inquiries in relation to the same
                  </p>
                </div>
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-theme" id="btn">
                  Submit
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div className="position-fixed bottom-0 end-0 m-3 z-index-5">
        <br />
        <button
          className="btn btn-theme btn-square rounded-circle shadow mt-2 d-none"
          id="backtotop"
        >
          <i className="bi bi-arrow-up" />
        </button>
      </div>
      <div
        className="offcanvas offcanvas-end shadow border-0"
        tabIndex={-1}
        id="theming"
        data-bs-scroll="true"
        data-bs-backdrop="false"
        aria-labelledby="theminglabel"
      >
        <div className="offcanvas-header border-bottom">
          <div>
            <h5 className="offcanvas-title" id="theminglabel">
              Personalize
            </h5>
            <p className="text-secondary small">Make it more like your own</p>
          </div>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <div className="offcanvas-body">
          <h6 className="offcanvas-title">Colors</h6>
          <p className="text-secondary small mb-4">Change colors of templates</p>
          <div className="row mb-4 theme-select">
            <div className="col-auto">
              <div className="select-box text-center mb-2" data-title="">
                <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                  <i className="bi bi-arrow-clockwise" />
                </span>
              </div>
            </div>
            <div className="col-auto">
              <div className="select-box text-center mb-2" data-title="theme-blue">
                <span className="avatar avatar-40 rounded-circle mb-2 bg-blue" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-indigo"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-indigo" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-purple"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-purple" />
              </div>
            </div>
            <div className="col-auto">
              <div className="select-box text-center mb-2" data-title="theme-pink">
                <span className="avatar avatar-40 rounded-circle mb-2 bg-pink" />
              </div>
            </div>
            <div className="col-auto">
              <div className="select-box text-center mb-2" data-title="theme-red">
                <span className="avatar avatar-40 rounded-circle mb-2 bg-red" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-orange"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-orange" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-yellow"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-yellow" />
              </div>
            </div>
            <div className="col-auto">
              <div className="select-box text-center mb-2" data-title="theme-green">
                <span className="avatar avatar-40 rounded-circle mb-2 bg-green" />
              </div>
            </div>
            <div className="col-auto">
              <div className="select-box text-center mb-2" data-title="theme-teal">
                <span className="avatar avatar-40 rounded-circle mb-2 bg-teal" />
              </div>
            </div>
            <div className="col-auto">
              <div className="select-box text-center mb-2" data-title="theme-cyan">
                <span className="avatar avatar-40 rounded-circle mb-2 bg-cyan" />
              </div>
            </div>
            <div className="col-auto">
              <div className="select-box text-center mb-2" data-title="theme-grey">
                <span className="avatar avatar-40 rounded-circle mb-2 bg-grey" />
              </div>
            </div>
            <div className="col-auto">
              <div className="select-box text-center mb-2" data-title="theme-brown">
                <span className="avatar avatar-40 rounded-circle mb-2 bg-brown" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-chocolate"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-chocolate" />
              </div>
            </div>
            <div className="col-auto">
              <div className="select-box text-center mb-2" data-title="theme-black">
                <span className="avatar avatar-40 rounded-circle mb-2 bg-dark" />
              </div>
            </div>
          </div>
          <h6 className="offcanvas-title">Backgrounds</h6>
          <p className="text-secondary small mb-4">Change color for background</p>
          <div className="row mb-4 theme-background">
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-default"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                  <i className="bi bi-arrow-clockwise" />
                </span>
              </div>
            </div>
            <div className="col-auto">
              <div className="gradient-box text-center mb-2" data-title="bg-white">
                <span className="avatar avatar-40 rounded-circle mb-2 bg-white" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-r-gradient"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-r-gradient" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-1"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-1" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-2"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-2" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-3"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-3" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-4"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-4" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-5"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-5" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-6"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-6" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-7"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-7" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-8"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-8" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-9"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-9" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-10"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-10" />
              </div>
            </div>
          </div>
          <h6 className="offcanvas-title">Sidebar Layout</h6>
          <p className="text-secondary small mb-4">Change sidebar layout style</p>
          <div className="row mb-4 sidebar-layout">
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="adminuiux-sidebar-standard"
                data-bs-toggle="tooltip"
                title="None"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                  <i className="bi bi-arrow-clockwise" />
                </span>
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="adminuiux-sidebar-iconic"
                data-bs-toggle="tooltip"
                title="Iconic"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                  <i className="bi bi-bezier h4" />
                </span>
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="adminuiux-sidebar-boxed"
                data-bs-toggle="tooltip"
                title="Boxed"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                  <i className="bi bi-box h5" />
                </span>
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="adminuiux-sidebar-boxed adminuiux-sidebar-iconic"
                data-bs-toggle="tooltip"
                title="Iconic+Boxed"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                  <i className="bi bi-bounding-box h5" />
                </span>
              </div>
            </div>
          </div>
          <div className="text-center mb-4">
            <a
              href="investment-personalization.html"
              className="btn btn-sm btn-outline-theme"
            >
              More options <i className="bi bi-arrow-right-short" />
            </a>
          </div>
        </div>
      </div>
    </>

  );
}